module.exports = __webpack_public_path__ + "static/media/icon6.ac2b721a.png";